import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'as-type-filter',
  templateUrl: './type-filter.component.html',
  styleUrls: ['./type-filter.component.scss']
})
export class TypeFilterComponent implements OnInit {
  model;
  filteredList = []

  @Input() data;
  @Input() filterOnKeys: Array<any>;
  @Input() placeholder: string = "Search";
  @Input() index: string = undefined;

  @Output() emmitFilteredList = new EventEmitter();
  @Output() emmitClearForStandalone = new EventEmitter()

  @ViewChild('filterField', {static: false}) filterField;

  constructor() {
  }

  ngOnInit() {
  }

  update(event) {

    if (event.length == 0) {
      this.clear()
    } else {

      this.filteredList = []

      this.filterOnKeys.forEach((y, inx) => {

        let k = this.data.filter((e) => {
          let er = (this.index) ? e[this.index] : e;
      return  er[y].toLocaleLowerCase().includes(event.toLocaleLowerCase())
        });
        k.forEach((l) => {
          if (!this.filteredList.includes(l)) {
            this.filteredList.push(l)
          }
        })

      })
      this.emmitFilteredList.emit(this.filteredList);
    }

  }

  clear() {
    this.filteredList = [];
    this.filterField.model = '';
    this.emmitFilteredList.emit(this.data);
    this.emmitClearForStandalone.emit(true)
  }

}
